import React, { useState } from "react";
import PropTypes from "prop-types";

import styles from "./UpcomingActionsList.module.css";

import UpcomingActionItem from "../UpcomingActionItem";

export function UpcomingActionsList({ upcomingActions, clearReminder }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>Incident #</div>
        <div>Reminder Reason</div>
        <div>Reminder</div>
        <div className={styles.lastItem}>Remove</div>
      </div>

      {upcomingActions.map((item, index) => (
        <div key={index}>
          <UpcomingActionItem
            index={index}
            actionDetails={item}
            clearReminder={clearReminder}
            onClick={() => {}}
          />
        </div>
      ))}
    </div>
  );
}

UpcomingActionsList.propTypes = {
  upcomingActions: PropTypes.arrayOf(PropTypes.object),
};
